import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import Debug from 'debug';
import { Observable } from 'rxjs';
import * as fromFeature from '../reducers/invitation.reducer';

import { invitation } from '../actions/invitations.actions';
import { AcceptInvitationDto } from '../dtos/acceptInvitationDto.interface';
import { GetInvitationDto } from '../dtos/getInvitationDto.interface';
import { ISetOrResetPasswordRequest } from '../interfaces/set-or-reset-password-request.interface';

const debug = Debug('aumico:aumico-lib-users-fe:UsersManagementProvider');

export interface IInvitationProvider {
    dispatchGetInvitationByUuid: (uuid: string) => void;
    dispatchAcceptInvitation: (
        uuid: string,
        acceptInvitationDto: AcceptInvitationDto,
        setPassword: ISetOrResetPasswordRequest,
    ) => void;
    getInvitation$: () => Observable<GetInvitationDto>;
    getError$: () => Observable<HttpErrorResponse>;
}

@Injectable({
    providedIn: 'root',
})
export class InvitationProvider implements IInvitationProvider {
    constructor(private readonly store: Store<fromFeature.AppState>) {
        debug('provider constructed');
    }
    dispatchGetInvitationByUuid(uuid: string): void {
        this.store.dispatch(invitation.get({ payload: uuid }));
    }
    dispatchAcceptInvitation(
        uuid: string,
        acceptInvitationDto: AcceptInvitationDto,
        setPassword: ISetOrResetPasswordRequest,
    ): void {
        this.store.dispatch(invitation.acceptInvitation({ payload: { uuid, acceptInvitationDto, setPassword } }));
    }
    getError$(): Observable<HttpErrorResponse> {
        return this.store.select(fromFeature.selectError);
    }

    getInvitation$(): Observable<GetInvitationDto> {
        return this.store.select(fromFeature.selectInvitation);
    }
}
